module.exports = __webpack_public_path__ + "img/10_26@2x.8bf9d338.png";